import React from 'react';

import TextView from 'components/TextView';
import styled from 'styled-components';

import YbCoreSpinner from '@yubi/yb-core-spinner';
import { useStyles } from '@yubi/yb-style-provider';

const SpinnerWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
`;

const SpinnerContainer = styled.div<{ blurBackground?: boolean }>`
  position: relative;
  /* display: inline-block; */
  top: 0;
  pointer-events: ${(props) => (props.blurBackground ? 'none' : '')};
  left: 0;
  width: 100%;
  height: 100%;
  opacity: ${(props) => (props.blurBackground ? 0.4 : 1)};
`;
interface YbCoreSpinnerProps {
  size?: 'large' | 'medium' | 'small';
  radius?: number;
  thickness?: number;
  label?: string;
  children?: React.ReactNode;
  spinning?: boolean;
  className?: string;
  testID?: string;
  labelPosition?: 'left' | 'right' | 'top' | 'bottom';
}

function Spinner({
  size = 'small',
  radius,
  thickness = 5,
  label,
  children,
  spinning,
  className,
  testID,
}: YbCoreSpinnerProps) {
  const { styleConnector } = useStyles();
  return (
    <>
      <SpinnerContainer className={className} blurBackground={spinning}>
        {spinning && (
          <SpinnerWrapper
            className={`flex flex-col items-center justify-center ${className}`}
          >
            <YbCoreSpinner
              size={size}
              testID={testID}
              durationInMills={1500}
              radius={radius}
              thickness={thickness}
              styleConnector={styleConnector}
            />
            {label && (
              <div className="my-1">
                <TextView text={label} />
              </div>
            )}
          </SpinnerWrapper>
        )}
        <>{children}</>
      </SpinnerContainer>
    </>
  );
}

export default Spinner;
